var exports = {
  "Qq": "ChannelReplyBar.module__text___YWk0dX",
  "Y_": "ChannelReplyBar.module__replyTargetButton___YWk0dX",
  "fh": "ChannelReplyBar.module__authorName___YWk0dX",
  "ne": "ChannelReplyBar.module__controls___YWk0dX",
  "xS": "ChannelReplyBar.module__mentionToggle___YWk0dX",
  "If": "ChannelReplyBar.module__mentionToggleOn___YWk0dX",
  "G9": "ChannelReplyBar.module__mentionToggleOff___YWk0dX",
  "mM": "ChannelReplyBar.module__mentionIcon___YWk0dX",
  "b": "ChannelReplyBar.module__closeButton___YWk0dX",
  "ut": "ChannelReplyBar.module__closeIcon___YWk0dX",
};

module.exports = exports;
